import React from 'react';
import {
  FaDesktop,
  FaCoins,
  FaDollarSign,
  FaChartLine,
  FaSyncAlt,
  FaHeart,
  FaExclamationTriangle,
  FaHdd
} from 'react-icons/fa';

export const MonitorIcon = () => <FaDesktop />;
export const MoneyIcon = () => <FaCoins />;
export const DollarIcon = () => <FaDollarSign />;
export const TrendingDownIcon = () => <FaChartLine />;

// ASG-specific icons
export const AutoScalingIcon = () => <FaSyncAlt />;
export const HealthyIcon     = () => <FaHeart style={{ color: '#10b981' }} />;
export const UnhealthyIcon   = () => <FaExclamationTriangle style={{ color: '#ef4444' }} />;
export const SavingsIcon     = () => <FaDollarSign />;

// EBS-specific icons
export const StorageVolumeIcon = () => <FaHdd />;
